/* Type theme */
/** ******************* */
var UitkIconThemeMap = [
    ['positive', 'uitk-icon-positive-theme'],
    ['negative', 'uitk-icon-negative-theme'],
    ['primary', 'uitk-icon-primary-theme'],
    ['secondary', 'uitk-icon-secondary-theme'],
    ['emphasis', 'uitk-icon-emphasis-theme'],
    ['default', 'uitk-icon-default-theme']
];
var UitkIconThemes = new Map(UitkIconThemeMap);

export { UitkIconThemes };
